export default {
    results: {},
    loading: false,
    error: null,
    errorShow: false
}